import React, { useContext } from 'react';

/* packages */
import { Fetch } from '../../../lib-atomic-functions';
/* packages */

/* stores */
import EmailResendStore from './store';
/* stores */

const index = ({CONFIG}) => {
  const accountEmailResendContext  = useContext(EmailResendStore);
  const accountEmailResendMethod = async ({token, traderId, actionId, body}) => {
    accountEmailResendContext.setLoading({loading: true, status: false, data: false});
    CONFIG.application.account.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.account.api.endpoints.emailResend.url,
      config: {
        method: CONFIG.application.account.api.endpoints.emailResend.method,
        headers: CONFIG.application.account.api.headers,
        
      }
    });
    accountEmailResendContext.setLoading({loading: false, status: fetch[0], data: fetch[1]});
  }

  return { accountEmailResendContext, accountEmailResendMethod }
}

export default index;
